<template>
  <Properties ref="properties" :tableData="tableData" :loading="loading" />
</template>

<script>
import Properties from './table.vue'
export default {
  components: { Properties },
  props: { chooseKeys: { type: Array, default: () => [] } },
  data() {
    return { tableData: [], loading: false }
  },
  async mounted() {
    await this.getData()
    setTimeout(() => {
      this.setCheckboxRecords()
    }, 0)
  },
  watch: {
    chooseKeys: {
      handler() {
        this.setCheckboxRecords()
      },
      deep: true,
    },
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .masterSamplePropertiesListApi({ listSamplePropertiesType: ['A', 'B'] })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    getCheckboxRecords() {
      return this.$refs.properties.getCheckboxRecords()
    },
    setCheckboxRecords() {
      this.$refs.properties.setCheckboxRecords(this.chooseKeys)
    },
  },
}
</script>

<style lang="scss" scoped></style>
